export default {
  Execution: {
    header: {
      title: 'Execution',
      actions: 'Actions',
    },
    pause_program_modal: {
      pause: 'Pause',
      resume: 'Resume',
      pause_title: 'Pause the program',
      resume_title: 'Resume the program',
      reason: 'Reason',
      select_reason: 'Select one reason to pause',
      drought: 'Drought',
      hail: 'Hail',
      lodging: 'Lodging',
      frost: 'Frost',
      other: 'Other',
      other_reason: 'Enter the reason',
      resume_explanation_title: 'The program is paused',
      resume_explanation:
        'When resuming the program, the system will recalculate the dates of each application and there may also be an impact on the efficiency of your program.',
      resume_confirmation: 'Are you sure you want to resume the program?',
      describe_reason: 'Describe',
    },
  },
}
